import axios, { AxiosRequestConfig } from 'axios';
import { ResponseCSOSHeaders } from '..';
import {
  compose as lcompose,
  filter as lfilter,
  negate as lnegate,
  eq as leq,
  prop as lprop,
} from 'lodash/fp';

const getOpenApiConfig = (): AxiosRequestConfig => ({
  withCredentials: `${process.env.REACT_APP_WITHCREDENTIALS}` === 'true',
});

const getApiConfig = (hR: ResponseCSOSHeaders): AxiosRequestConfig => ({
  withCredentials: `${process.env.REACT_APP_WITHCREDENTIALS}` === 'true',
  headers: {
    'Content-type': 'application/json',
    'x-csrf-csos-token': `${hR['x-csrf-csos-token']}`,
    authorization: `${hR.authorization}`,
  },
});

export const csosApi = (baseURL: string) =>
  lcompose(
    axios.create,
    a => ({
      ...a,
      baseURL,
    }),
    getApiConfig
  );

export const csosUpmApi = lcompose(
  axios.create,
  a => ({
    ...a,
    baseURL: `${process.env.REACT_APP_API_USER_PROFILE_MGMT_URL}`,
  }),
  getApiConfig
);

export const csosApproverApi = lcompose(
  axios.create,
  a => ({
    ...a,
    baseURL: `${process.env.REACT_APP_API_APPROVER_URL}`,
  }),
  getApiConfig
);

export const csosRequestMgmtApi = lcompose(
  axios.create,
  a => ({
    ...a,
    baseURL: `${process.env.REACT_APP_API_REQUEST_MGMT_URL}`,
  }),
  getApiConfig
);

export const csosTokenGenApi = lcompose(
  axios.create,
  a => ({ ...a, baseURL: `${process.env.REACT_APP_API_TOKEN_GEN_URL}` }),
  getOpenApiConfig
);

export const csosIcamServiceApi = lcompose(
  axios.create,
  a => ({ ...a, baseURL: `${process.env.REACT_APP_API_ICAM_SERVICE_URL}` }),
  getOpenApiConfig
);

export const csosOktaApi = lcompose(axios.create, () => ({
  baseURL: `${process.env.REACT_APP_OKTA_ORG_URL}`,
}));

export type IApiCallStatus = undefined | null | true | false;

export const deleteApiCallStatus = ({ type }: { type: string }) =>
  lfilter(lcompose(lnegate(leq(type)), lprop('type')));
